import React, { useContext, useState } from 'react';
import ReactLoading from 'react-loading';
import moment from 'moment';

import { HandleEditRemark, HandleDeleteRemark } from './requests/RemarkRequests';
import { DeepCopy } from '../shared/TableEventHelpers';
import CustomModal from '../shared/CustomModal';
import TextareaAutosize from 'react-textarea-autosize';
import { DataContext } from '../../../stores/covering-table-store';

const deleteButtonClassName = 'btn btn-sm d-flex justify-content-center align-items-center w-100 h-100 padding-none';
const remarkWrittenByClassName = 'text-left w-100 remark-written-by';

const RemarkInput = ({ id, row, element, setIsAlertModalOpen, setAlertModalContent }) => {
    const {
        store: { coverings },
        dispatch,
    } = useContext(DataContext);

    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [editableDivContent, setEditableDivContent] = useState(element.dsc);

    async function handleDeleteContent(empID, remID) {
        setIsDeleting(true);
        let deleteResult = await HandleDeleteRemark(empID, remID, coverings, row, setIsDeleting);

        if (!deleteResult.error) {
            dispatch({ type: 'SHOW_DELETED_TOAST' });
            dispatch({
                type: 'UPDATE_REMARKS_COVERINGS',
                payload: deleteResult.coverings,
            });
        } else {
            setAlertModalContent(deleteResult.error);
            setIsAlertModalOpen(true);
        }
    }

    async function handleEditContent(empID, remID, dsc) {
        let newCommentDivContainer = document.getElementById(id + '-remark-note-text-section');
        newCommentDivContainer.style.height = newCommentDivContainer.clientHeight.toString() + 'px';

        let trimmedContent = DeepCopy(editableDivContent).trim();
        if (dsc !== trimmedContent) {
            if (trimmedContent.length !== 0) {
                setIsSaving(true);
                let editResult = await HandleEditRemark(empID, remID, trimmedContent, coverings, row, setIsSaving, dispatch);

                if (!editResult.error) {
                    dispatch({ type: 'SHOW_SAVED_TOAST' });
                } else {
                    setAlertModalContent(editResult.error);
                    setIsAlertModalOpen(true);
                }
            } else {
                handleDeleteContent(empID, remID);
            }
        }

        newCommentDivContainer.style.height = 'auto';
        hideDeleteButton(id);
        hideWrittenBy(id);
    }

    return (
        <>
            <div id='complete-comment-card' className='comment-section padding-bottom-5px'>
                <div className='d-flex'>
                    <div id={id + '-comment-card'} className='bg-yellow remark-note-text-section comment-card remark-note-section'>
                        <div id={id + '-remark-note-text-section'} className=' position-relative'>
                            {isSaving && <SavingLoader />}
                            <TextareaAutosize
                                className={`bg-yellow border-0 no-scroll-bar outline-none w-100 ${isSaving ? 'invisible' : 'visible'}`}
                                maxLength='200'
                                minRows={1}
                                defaultValue={editableDivContent}
                                onFocus={() => {
                                    showDeleteButton(id);
                                    showWrittenBy(id);
                                }}
                                onInput={(e) => {
                                    setEditableDivContent(e.currentTarget.value);
                                }}
                                onBlur={() => handleEditContent(element.empID, element.remID, element.dsc)}
                                style={{ resize: 'none' }}
                                wrap='hard'
                            />
                        </div>
                    </div>
                    <div className='remark-delete-button-section d-flex my-auto'>
                        <div className='d-flex justify-content-center align-items-center w-100 h-75 m-auto'>
                            <button
                                id={id + '-delete-remark-button'}
                                type='button'
                                title='Ta bort'
                                className={deleteButtonClassName}
                                onClick={() => {
                                    showDeleteButton(id);
                                    setIsDeleteModalOpen(true);
                                }}>
                                {isDeleting ? <DeleteLoader /> : <i className='oi oi-trash d-flex m-auto' />}
                            </button>
                        </div>
                    </div>
                </div>
                <div id={id + '-remark-written-by'} className={remarkWrittenByClassName}>
                    {moment(element.modDat).format('YYYY-MM-DD').toString()}, {element.modEmpName}{' '}
                </div>
            </div>

            <div className='covering-modals'>
                {isDeleteModalOpen ? (
                    <CustomModal
                        show={isDeleteModalOpen}
                        onHide={() => {
                            hideDeleteButton(id);
                            setIsDeleteModalOpen(false);
                        }}
                        handleModal={() => {
                            handleDeleteContent(element.empID, element.remID);
                            setIsDeleteModalOpen(false);
                        }}
                        modalText='Är du säker på att du vill ta bort kommentaren?'
                        buttonText='Ta bort'
                        modalVariant='danger'
                    />
                ) : null}
            </div>
        </>
    );
};

export default RemarkInput;

const SavingLoader = () => {
    return (
        <div className='d-flex justify-content-center align-items-center h-100 w-100'>
            <ReactLoading type={'bars'} color={'#262f3d'} height={25} width={25} />
        </div>
    );
};

const DeleteLoader = () => {
    return (
        <div className='d-flex justify-content-center align-items-center h-100 w-100'>
            <ReactLoading className='m-auto' type={'bars'} color={'#262f3d'} height={20} width={20} />
        </div>
    );
};

const showDeleteButton = (id) => {
    let deleteButton = document.getElementById(id + '-delete-remark-button');
    if (deleteButton) {
        deleteButton.className += ' show-button';
    }
};

const hideDeleteButton = (id) => {
    let deleteButton = document.getElementById(id + '-delete-remark-button');
    if (deleteButton) {
        deleteButton.className = deleteButtonClassName;
    }
};

const showWrittenBy = (id) => {
    let remarkWrittenBy = document.getElementById(id + '-remark-written-by');
    if (remarkWrittenBy) {
        remarkWrittenBy.className += ' show-button';
    }
};

const hideWrittenBy = (id) => {
    let remarkWrittenBy = document.getElementById(id + '-remark-written-by');
    if (remarkWrittenBy) {
        remarkWrittenBy.className = remarkWrittenByClassName;
    }
};
